// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".bdc-nav[data-v-d53a70f0]{color:#454647;font-size:14px}@media (min-width:1024px){.bdc-nav[data-v-d53a70f0]{padding-left:5rem;padding-right:5rem;padding-top:1.5rem}}.breadcrumb-link[data-v-d53a70f0]{font-size:1.4rem;text-decoration-line:underline}.breadcrumb-link.nuxt-link-active[data-v-d53a70f0]{pointer-events:none;-webkit-text-decoration:none;text-decoration:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
